module.exports = ".card-img-top{\n  margin-left: 50px; width: 250px;height: 100px;\n}\n.row{\n  margin-top: 50px;\n}\n.card col-lg-4{\n  width: 250px;height: 100px\n}\n.card-title{\n  margin-left: 50px\n\n}\n.card-text{\n  margin-left: 50px\n\n}\n.btn.btn-primary{\n  margin-left: 50px\n}\n/*.col-lg-4{ width: 425px;height: 75px;\n\n}*/\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/dashboard/dashboard.component.css
// module id = ./src/app/component/dashboard/dashboard.component.css
// module chunks = main